// Module
var code = "<sidebar v-if=\"!hiddenSidebar\"\n\t\t:opened=\"opened\"\n\t\t:minimized=\"minimized\"\n\t\t:header=\"header\"\n\t\t:menus=\"menus\">\n</sidebar>\n";
// Exports
export default code;